"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs3/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _parseInt2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/parse-int"));
var _indexOf = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/index-of"));
var _trim = _interopRequireDefault(require("@babel/runtime-corejs3/core-js/instance/trim"));
class MessageInjector {
  constructor(params, wraps, stringWrap) {
    this.params = params;
    this.wraps = wraps;
    this.stringWrap = stringWrap;
  }
  getElements(text) {
    const elements = [];
    let i = 0;
    while (i < text.length) {
      const prefix = text.substring(i).match(/^[^[*_{]+/);
      if (prefix !== null) {
        elements.push(this.stringWrap(prefix[0]));
        i += prefix[0].length;
      }
      const chr = text[i];
      if (chr === '{') {
        if (text[i + 1] >= '1' && text[i + 1] <= '9' && text[i + 2] === '}') {
          // single brackets with numbered keys (i.e. params is an array)
          elements.push(this.stringWrap(this.params[(0, _parseInt2.default)(text[i + 1]) - 1]));
          i += 3;
        } else if (text[i + 1] === '{') {
          var _context;
          // double brackets
          const closingBracketIndex = (0, _indexOf.default)(text).call(text, '}', i + 2);
          const key = (0, _trim.default)(_context = text.substring(i + 2, closingBracketIndex)).call(_context);
          const value = this.params[key];
          elements.push(this.stringWrap(value));
          i = closingBracketIndex + 2;
        } else {
          elements.push(this.stringWrap(text[i++]));
        }
      } else if (chr === '[' || chr === '_' || chr === '*') {
        let closeTag;
        let type;
        let used = chr;
        if (text[i + 1] === chr && chr !== '[') {
          type = 'strong';
          closeTag = chr + chr;
          used += text[i + 1];
          i += 2;
        } else {
          i += 1;
          type = chr === '[' ? 'link' : 'em';
          closeTag = chr === '[' ? ']' : chr;
        }
        const i2 = (0, _indexOf.default)(text).call(text, closeTag, i);
        if (i2 !== -1) {
          let skip = 0;
          // eslint-disable-next-line max-depth
          if (closeTag === ']' && text.length > i2 + 3 && text[i2 + 1] === '(' && text[i2 + 2] >= '1' && text[i2 + 2] <= '9' && text[i2 + 3] === ')') {
            skip = 3;
            type = `link${text[i2 + 2]}`;
          }
          elements.push(this.wraps[type](this.getElements(text.substring(i, i2))));
          i = i2 + closeTag.length + skip;
        } else {
          elements.push(this.stringWrap(used)); // If we don't find a close tag, just emit the tag as text.
        }
      }
    }
    return elements;
  }
}
exports.default = MessageInjector;